import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import stateService from './StateService';

export const getAllState = createAsyncThunk(
	'state/getAll',
	async (_, thunkAPI) => {
		try {
			const token = thunkAPI.getState().auth.mainUser.data.token;
			return stateService.getAllState(token);
		} catch (error) {
			const massage = error.message;
			return thunkAPI.rejectWithValue(massage);
		}
	},
);

const statesSlice = createSlice({
	name: 'state',
	initialState: {
		states: [],
		isStateSuccess: false,
		isStateErorr: false,
		isStatesloading: false,
		massage: '',
	},
	reducers: {
		resetState: (state) => {
			state.isStateSucsess = false;
			state.isStateErorr = false;
			state.isStatesloading = false;
			state.massage = '';
		},
	},
	extraReducers: {
		[getAllState.pending]: (state) => {
			state.isStatesloading = true;
		},
		[getAllState.fulfilled]: (state, action) => {
			state.isStatesloading = false;
			state.states = action.payload;
			state.isStateSuccess = true;
		},
		[getAllState.rejected]: (state, action) => {
			state.isStatesloading = false;
			state.isStateErorr = true;
			state.massage = action.payload;
			state.states = [];
		},
	},
});

export const { resetState } = statesSlice.actions;
export default statesSlice.reducer;
